import { Excel } from 'antd-table-saveas-excel'
import moment from 'moment'
import { message } from 'ant-design-vue'
import { useCookies } from 'vue3-cookies'

import type { OrgUnit } from '@/types/models'
const { cookies } = useCookies()

const domain = import.meta.env.VITE_DOMAIN_URL
export const getItemFromCookies = (key: string) => {
  return JSON.parse(JSON.stringify(cookies.get(key) || '{}'))
}

export const getItemFromLocalStorage = (key: string): any => {
  const item = localStorage.getItem(key)
  if (!item) return null

  try {
    return JSON.parse(item)
  } catch (error) {
    console.log(error)
    return null
  }
}

export const setItemToCookies = (key: string, payload: any): any => {
  const currentDomain = window.location.hostname
  return !currentDomain.includes(domain)
    ? cookies.set(key, payload)
    : cookies.set(key, payload, '30d', '/', domain)
}

export const isEmptyObject = (obj: object) => {
  return Object.keys(obj).length === 0
}

export const filterDataTree = (list: any) => {
  list = list.filter((item: any) => {
    return String(item.allow) === '1'
  })
  return list
}
export const buildTree = (list: OrgUnit[]) => {
  const map: any = {}
  let node
  const roots = []
  const length = list.length
  for (let i = 0; i < length; i += 1) {
    map[list[i].orgUnitId] = i
    list[i].children = []
    list[i].title = list[i].orgUnitName
    list[i].key = list[i].orgUnitId
  }
  for (let i2 = 0; i2 < length; i2 += 1) {
    node = list[i2]
    if (node.upperOrgUnitId !== null) {
      if (list[map[node.upperOrgUnitId]]) {
        node.value = node.orgUnitName
        list[map[node.upperOrgUnitId]].children.push(node)
      } else {
        roots.push(node)
      }
    } else {
      roots.push(node)
    }
  }
  return roots
}
export function onExportExcel(columnsTable: any, dataTable: any, router: any) {
  const excel = new Excel()
  const columnsExcel = columnsTable
    .filter((c: { dataIndex: string }) => c.dataIndex !== 'action')
    .map((e: { title: any; children: any }) => {
      return {
        ...e,
        title: e?.title || '',
      }
    })
  const nameRouter = router.currentRoute.value?.meta?.title || ''
  const today = moment().format('HH:mm:ss/DD-MM-YYYY')

  const nameExcel = `Báo cáo ${nameRouter}(${today})`.replace(/\s/g, '_') || 'excel'

  excel
    .addSheet(today)
    .addColumns(columnsExcel)
    .addDataSource(dataTable, {
      str2Percent: true,
    })
    .saveAs(`${nameExcel}.xlsx`)
}

export const getTableRowIndex = (
  pageSize: number,
  currentPage: number,
  rowIndex: number
): number => {
  let current = currentPage
  if (currentPage === 0) {
    current = 0
  }
  return current * pageSize + rowIndex + 1
}

export const copyTextToClipboard = (text: string) => {
  const input = document.createElement('input')
  input.value = text
  document.body.appendChild(input)
  input.select()
  document.execCommand('copy')
  document.body.removeChild(input)

  message.success('Copy thành công')
}

export const formatRelativeTime = (inputDate: moment.MomentInput) => {
  const inputMoment = moment(inputDate, 'DD/MM/YYYY HH:mm')
  const currentMoment = moment()
  const timeDifference = currentMoment.diff(inputMoment, 'seconds')

  if (timeDifference < 60) {
    return 'Vừa xong'
  } else if (timeDifference < 3600) {
    const minutesAgo = Math.floor(timeDifference / 60)
    return `${minutesAgo} phút trước`
  } else if (timeDifference < 86400) {
    const hoursAgo = Math.floor(timeDifference / 3600)
    return `${hoursAgo} giờ trước`
  } else if (timeDifference < 2592000) {
    const daysAgo = Math.floor(timeDifference / 86400)
    return `${daysAgo} ngày trước`
  } else if (timeDifference < 31536000) {
    const monthsAgo = Math.floor(timeDifference / 2592000)
    return `${monthsAgo} tháng trước`
  } else {
    return inputMoment.format('DD/MM/YYYY HH:mm')
  }
}

export const renderProcessColorByState = (state: number | string) => {
  const colors: Record<number, string> = {
    // 0: '#F39C12',
    1: '#F39C12',
    2: '#27AE60',
    3: '#2980B9',
    4: '#8E44AD',
    5: '#16A085',
    6: '#F1C40F',
  }

  return colors[Number(state)] ?? null
}

export const renderColorByTaskState = (state: number | string) => {
  const colors: Record<number, string> = {
    1: '#E74C3C',
    2: '#27AE60',
    3: '#2980B9',
    4: '#6d6d6d',
    5: '#000000',
  }
  return colors[Number(state)] || null
}
